import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {fetchArticlesAid} from '../../actions/homeAction';
import './index.scss';

class PageInfo extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            articles: {}
        };
    }

    componentDidMount() {
        const articleId = this.props.match.params.id;
        this.props.fetchArticlesAid(articleId).then(data => { // 文章详情
            if (data.code === 200) {
                this.setState({
                    articles: data.message
                });
                // 动态设置新闻标题和内容
                document.title = data.message.title;
                let metaTag = document.querySelector('meta[name="description"]');
                if (!metaTag) {
                    metaTag = document.createElement('meta');
                    metaTag.name = 'description';
                    document.head.appendChild(metaTag);
                }
                // 去除HTML标签并截取前150个字符
                const rawContent = data.message.content.replace(/<[^>]+>/g, '');
                const plainText = rawContent.substring(0, 150);
                metaTag.content = plainText;

                // 设置keywords meta标签
                let keywordsTag = document.querySelector('meta[name="keywords"]');
                if (!keywordsTag) {
                    keywordsTag = document.createElement('meta');
                    keywordsTag.name = 'keywords';
                    document.head.appendChild(keywordsTag);
                }
                keywordsTag.content = [
                    data.message.title,
                    data.message.author,
                    data.message.publish_time,
                    '反欺诈',
                    '百度安全'
                ].join(',');
            }
        });
    }

    render() {
        let articles = this.state.articles;
        return (
            <div className={'pageInfo'}>
                {
                    !this.isEmptyobj(articles)
                        ? <div>
                            <div className={'page-title'}>
                                {articles.title}
                            </div>
                            <div className={'page-des'}>
                                {articles.publish_time}
                                <span>作者：{articles.author}</span>
                            </div>
                            <div
                                className={'page-con'}
                                dangerouslySetInnerHTML={{
                                    __html: articles.content
                                }}
                            />
                            <div
                                className={'page-btn'}
                                onClick={() => {
                                    window.location.href = `/fqz/${this.props.match.params.type}`;
                                }}
                            >
                                返回目录
                            </div>
                        </div>
                        : null
                }


            </div>
        );
    }
}

PageInfo.propTypes = {
    fetchFqzArticles: PropTypes.func
};

function mapStateToProps(state) {
    return {
        articlesBD: state.articlesBD,
        fqzArticles: state.fqzArticles
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchArticlesAid: params => fetchArticlesAid(dispatch, params)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageInfo);